export default "__VITE_ASSET__CV_iHm1O__"